export const appSettings = setSettings();

async function setSettings() {
   let settings_promise = await fetch("conf.json", {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
  let settings = await settings_promise.json();

  return settings;
}
